var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNeu1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 101.596L74.3569 82H82.4257L74.3569 96.1203L83.002 99.002L68.8817 117.733L73.7806 101.596H66Z",
    fill: "#AFABD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3786 43.1283C76.6152 30.2183 70.3716 37.7491 67.9701 43.1283C59.6709 36.9034 57.5961 42.4561 57.5961 46.0105C50.9108 42.0914 49.8154 48.7961 50.1033 52.6384C41.1125 53.33 44.2441 60.6111 46.9338 64.1652C38.404 74.3087 50.4879 76.8446 57.5961 76.8446C58.7487 84.6828 64.9924 81.8396 67.9701 79.4382C67.9701 84.7405 74.8862 84.1449 78.3442 83.1844C82.0328 85.0286 84.4919 82.4159 85.2603 80.879C94.7123 86.1813 97.2674 80.3987 97.3634 76.8446C116.959 78.9195 110.907 66.1824 105.432 59.5545C111.887 49.872 102.743 48.2198 97.3634 48.604C100.36 33.3887 88.6223 38.6138 82.3786 43.1283Z",
    fill: "#52537A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeu1);
export default __webpack_public_path__ + "static/media/neu-1.c1f1b8a5d167ffd4f8e0e363a42cca2b.svg";
export { ForwardRef as ReactComponent };